export const STALE_TIME = 60_000;

export enum RESPONSE_CODES {
  Success = 200,
  InvalidAuth = 401,
}
